
$(document).ready(function(){
  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    var drawercart = document.querySelector('cart-drawer'); 
    drawercart.open();
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }

  var currencyFormat = window.routes.moneyFormat;
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.routes.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  $('.main-product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    asNavFor: '.thumb-images-slider'
  });

  var $slider = $('.announcement_bar_slider_custom');

  var slideauto = $slider.closest('.announcement_bar_custom').attr('data-autoplay');
  var slidespeed = parseInt($slider.closest('.announcement_bar_custom').attr('data-speed'), 10) || 3000;
  
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: slideauto,
    autoplaySpeed: slidespeed,
    speed: 1000,
    infinite: true,
    adaptiveHeight: false,
    prevArrow: $('.announcement_bar_custom .slick_slider-button--prev'),
    nextArrow: $('.announcement_bar_custom .slick_slider-button--next')
  });

  function arrow(dir) {
    var path = dir === 'prev'
      ? 'M15 6l-6 6 6 6'
      : 'M9 6l6 6-6 6';
    return "<button type='button' class='slick-arrow slick-" + dir + "' aria-label='" + dir + "'>" +
      "<svg viewBox='0 0 24 24' width='18' height='18' xmlns='http://www.w3.org/2000/svg'>" +
      "<path d='" + path + "' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'/></svg></button>";
  }

  $('.bestseller-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: true,
    appendArrows: window.jQuery('.bestseller-nav'),
    prevArrow: arrow('prev'),
    nextArrow: arrow('next'),
    responsive: [
      { breakpoint: 990, settings: { slidesToShow: 3 } },
      { breakpoint: 750, settings: { slidesToShow: 1.5, arrows: true } }
    ]
  });

  $('.thumb-images-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    asNavFor: '.main-product-images',
    focusOnSelect: true
  });
  $('.review-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false
  });
  $('.testionial-content-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.fbt-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        }
      }
    ]
  });

  if($(window).width() < 768){
    $(".as_easy_as_pdp .image-wrapper-blocks").slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    })
  }

  $('.wfsbm-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false
  });

  $('.wfsbms-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false
  });

  $('.video_slideshow .slideshow_slider_wrapper_new').slick({
    infinite: true,
    autoplay: false, 
    arrows: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $(".videolist_flex").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    variableWidth: true, 
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    prevArrow:`<button type='button' class='slick-prev pull-left'><svg stroke="#fff" fill="#fff" stroke-width="0" viewBox="0 0 16 16" height="30" width="30" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"></path></svg></button>`,
    nextArrow: `<button type='button' class='slick-next pull-right'><svg stroke="#fff" fill="#fff" stroke-width="0" viewBox="0 0 16 16" height="30" width="30" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          draggable: false,
          centerMode: false,
          slidesToShow: 1,
          variableWidth: false 
        }
      }
    ]
  });

  $(".video-carousel").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    prevArrow:`<button type='button' class='slick-prev pull-left'><svg width="15" height="15" stroke="rgba(255,255,255, 1)" fill="rgba(255,255,255, 1)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z" fill="rgba(255,255,255, 1)"></path></svg></button>`,
    nextArrow: `<button type='button' class='slick-next pull-right'><svg width="15" height="15" stroke="rgba(255,255,255, 1)" fill="rgba(255,255,255, 1)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z" fill="rgba(255,255,255, 1)"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".video-carousel-pdp").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:`<button type='button' class='slick-prev pull-left'><svg width="15" height="15" stroke="rgba(255,255,255, 1)" fill="rgba(255,255,255, 1)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z" fill="rgba(255,255,255, 1)"></path></svg></button>`,
    nextArrow: `<button type='button' class='slick-next pull-right'><svg width="15" height="15" stroke="rgba(255,255,255, 1)" fill="rgba(255,255,255, 1)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z" fill="rgba(255,255,255, 1)"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  if(window.variantStrings.pageType == 'product'){  
    // Set the date we're counting down to
    var time = $('#demo').attr('data-time');
    var countDownDate = new Date(time).getTime();
  
    // Update the count down every 1 second
    var x = setInterval(function() {
  
      // Get today's date and time
      var now = new Date().getTime();
  
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
  
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      // Display the result in the element with id="demo"
      if(days > 1){
      var daytext = 'days';
      }else{
      var daytext = 'day';
      }
      document.getElementById("demo").innerHTML = days + " "+ daytext + ' ' + hours + " hrs " + minutes + " mins " + seconds + " sec";
  
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("demo").parentElement.classList.add('removed');
      }else if(document.getElementById("demo").closest('.offer_timer_msg').classList.contains('removed')){
        document.getElementById("demo").closest('.offer_timer_msg').classList.remove('removed');
      }
    }, 1000);
  }

  $('body').on('mouseover','.list-menu .details', function(){
    $(this).attr('open','');
  });
  
  $('body').on('mouseout','.list-menu .details', function(){
    $(this).removeAttr('open');
  });

  $('body').on('click','.moreinfo_pop', function(){
    $('.page-container').addClass('modal-open');
    $('.more-info-popup').addClass('open');
  });
  $('body').on('click','.more-info-close',function(){
    $('.page-container').removeClass('modal-open');
    $('.more-info-popup').removeClass('open');
  });
  

  function formatMoneyWithoutTrailingZeros(cents, format = window.routes.moneyFormat) {
    // format normally (with decimals)
    let formatted = formatMoney(cents, format);
    // remove .00 only at the end
    return formatted.replace(/(\.\s?00)(?!\d)/, '');
  }

  function triggerVariantChange(data) {
    var jsonText = $(data).find("[data-selected-variant]").text();
    var variant = JSON.parse(jsonText);
    const newUrl = new URL(window.location.href);
    if (variant) {
      if(variant.available){
        $('.product__info-wrapper [data-custom-addtocart],[data-custom-stickyaddtocart]').removeAttr('disabled').find('.button-text').text(window.variantStrings.addToCart);
      }else{
        $('.product__info-wrapper [data-custom-addtocart],[data-custom-stickyaddtocart]').attr('disabled',true).find('.button-text').text(window.variantStrings.soldOut);
      }
      newUrl.searchParams.set("variant", variant.id);
      $('.input_wrapper_custom[name="id"]').val(variant.id);
      
      // URL CHANGE
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());

      // META CONTENT CHANGE
      var metajsonText = $(data).find("#selectedvarmetaJson").text();
      var varproductData = JSON.parse(metajsonText);
      if (varproductData) {
        $('[data-variantweight]').html(varproductData.weight);
      } else {
        console.log('Variant not found');
      }
      if(varproductData.vardescription != ''){
        $('[data-product-description]').html(varproductData.vardescription);
      }else{
        $('[data-product-description]').html(varproductData.description);
      } 
      
      // IMAGE CHANGE
      $('.custom-product-images').html($(data).find(".custom-product-images").html());
      setTimeout(function() {
        $('.custom-product-images').find('.main-product-images').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          adaptiveHeight: true,
          asNavFor: '.thumb-images-slider'
        });
        $('.custom-product-images').find('.thumb-images-slider').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          asNavFor: '.main-product-images',
          focusOnSelect: true
        });
        // mainprdimg.closest('.custom-product-images').css('opacity', '1');
      }, 50);

      // PRICE CHANGE
      $('[data-custom-product-price-list]').html($(data).find("[data-custom-product-price-list]").html());
      $('[data-stickybar]').html($(data).find("[data-stickybar]").html());

      $('[data-custom-product-price-list]').html($(data).find("[data-custom-product-price-list]").html());
      $('[data-stickybar]').html($(data).find("[data-stickybar]").html());
      if(variant.available){
        $('.estimate_delivery_widget').show();
      }else{
        $('.estimate_delivery_widget').hide();
      }
      if($('.estimate_delivery_widget .edd-input').length > 0){
        $('.estimate_delivery_widget .edd-input').attr('data-currentvid',variant.id);
        if($('.estimate_delivery_widget .edd-input').val() != '' && !$('.custom-product-tab').hasClass('active')){
          $('.estimate_delivery_widget .edd-btn').trigger('click');
        }
      }
    }else{
      $('.estimate_delivery_widget').hide();
      $('.product__info-wrapper [data-custom-addtocart],[data-custom-stickyaddtocart]').attr('disabled',true).find('.button-text').text(window.variantStrings.unavailable);
      newUrl.searchParams.delete("variant");
    }
    
  }

  // function getvariant(selectionvalue){
  //   // var prddata = JSON.parse($('#productJson').html());
  //   var createURL = 
  //   console.log(allVariants)
  //   var selectedvariant = allVariants.filter(function(v){
  //       return v.title == selectionvalue;    
  //     });
  //     return selectedvariant[0];
  // }
  
  function selectvalue(selector){ 
    var values = [];
    for(var i = 0;i < 3;i++){
      if(selector.find('[data-index="'+i+'"]').length > 0){
        if(selector.find('[data-index="'+i+'"] input[type="radio"]').length > 0){
          values.push(selector.find('[data-index="'+i+'"] input[type="radio"]:checked').attr('data-option-value-id'));
        }else{
          if(selector.find('[data-index="'+i+'"]').closest('.categorywise_selector').length > 0){
            values.push(selector.find('.categorywise_selector.active [data-index="'+i+'"] option:selected').attr('data-option-value-id'));
          }else{
            values.push(selector.find('[data-index="'+i+'"] option:selected').attr('data-option-value-id'));
          }
        }
      }
    }
    if(values.length > 0){
      var sectionId = selector.closest('product-info').attr('sectionId');
      var productHandle = selector.closest('product-info').attr('data-product-handle');
      var createURL = `/products/${productHandle}?section_id=${sectionId}&option_values=${values.join(',')}`
      async function fetchPage(createURL) {
        try {
          const data = await $.get(createURL);

          return data;
        } catch (e) {
          console.error("Error fetching page:", page, e);
          return false;
        }
      }

      return fetchPage(createURL);  
    }else{
      return null;
    }    
  }

  $('body').on('click','.item_toggler [data-category-toggler]', function(){
    $(this).closest('.variant_picker_custom').find('[data-size="predefined"]').show();
    $(this).closest('.variant_picker_custom').find('.custom-product-tab').removeClass('active');
    $(this).closest('.product__info-container').find('[data-checkprice]').hide();
    $(this).closest('.product__info-container').find('[data-custom-addtocart]').show();
    
    $('[data-stickybar]').find('[data-checkprice]').hide();
    $('[data-stickybar]').find('[data-custom-stickyaddtocart]').show();
    if($(window).width() < 767){
      $('[data-custom-addtocart]').show();
      $('.mobile-sticky-button .mobile-price-wrap').show();
    }
    $(this).closest('.product__info-container').find('.desk-price-wrapper').hide();
    $(this).closest('.variant_picker_custom').find('[data-size="custom"]').hide();
    if($('.estimate_delivery_widget .edd-input').length > 0){
      $('.estimate_delivery_widget .edd-input').attr('data-iscustom',false);
    }
    $(this).closest('.item_main').find('[data-category-toggler]').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.variant_picker_custom').find('.categorywise_selector').removeClass('active');
    $(this).closest('.variant_picker_custom').find('.categorywise_selector[data-currentcat="'+$(this).attr('data-value')+'"]').addClass('active');
    $(this).closest('.variant_picker_custom').find('.custom_sizes_boxes input').val('');
    selectvalue($(this).closest('.variant_picker_custom'))
    .then(val => {
        triggerVariantChange(val);
    });
  });

  var allVariants = [];
  var originalallVariants = [];
  var allExtra = {};
  var customhasoriginal = false;

  $('body').on('click','.item_toggler .custom-product-tab', function(){
    $(this).closest('.variant_picker_custom').find('[data-category-toggler]').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.variant_picker_custom').find('[data-size="predefined"]').hide();
    $(this).closest('.variant_picker_custom').find('[data-size="custom"]').show();
    if($('.estimate_delivery_widget .edd-input').length > 0){
      $('.estimate_delivery_widget .edd-input').attr('data-iscustom',true);
    }
    $(this).closest('.product__info-container').find('[data-checkprice]').show();
    $(this).closest('.product__info-container').find('[data-custom-addtocart]').hide();

    $('[data-stickybar]').find('[data-checkprice]').show();
    $('[data-stickybar]').find('[data-custom-stickyaddtocart]').hide();
    if($(window).width() < 767){
      // $('[data-customsize-button]').hide();
      $('.mobile-sticky-button .mobile-price-wrap').hide();
    }
    $('.estimate_delivery_widget .edd-message').hide().removeClass('edd-success');
    var totalpage = Math.ceil(parseInt($('product-info').attr('data-variant-count')) / 250);
    
    if($('product-info').attr('data-customproduct-handle')){
      var productHandle = $('product-info').attr('data-customproduct-handle');
    }else{
      var productHandle = $('product-info').attr('data-product-handle');
    }
    
    function fetchPage(page, callback) {
      $.get(`/products/${productHandle}?page=${page}&view=dev-use-temp`, function (data) {
        // Parse the JSON inside <script id="productJson">
        var jsonText = $(data).find("#productJson").text();
        var productData = JSON.parse(jsonText);

        // Add variants
        allVariants = allVariants.concat(productData.variants);

        // Merge extra info
        $.extend(allExtra, productData.variants_extra);

        if (callback) callback();
      });
    }

    function fetchAllPages() {
      var page = 1;

      function next() {
        if (page <= totalpage) {
          fetchPage(page, function () {
            page++;
            next();
          });
        } else {
          // ✅ Done – all pages loaded
        }
      }

      next();
    }

    fetchAllPages();

    
    var orproductHandle = $('product-info').attr('data-product-handle');
    function originalfetchPage(page, callback) {
      $.get(`/products/${orproductHandle}?page=${page}&view=dev-use-temp`, function (data) {
        // Parse the JSON inside <script id="productJson">
        var jsonText = $(data).find("#productJson").text();
        var productData = JSON.parse(jsonText);

        // Add variants
        originalallVariants = originalallVariants.concat(productData.variants);

        // Merge extra info
        $.extend(allExtra, productData.variants_extra);

        if (callback) callback();
      });
    }

    function orfetchAllPages() {
      var page = 1;

      function next() {
        if (page <= totalpage) {
          originalfetchPage(page, function () {
            page++;
            next();
          });
        } else {
          // ✅ Done – all pages loaded
        }
      }

      next();
    }

    orfetchAllPages();
    
  });

  function findcustomsize_variant(allVariants,closest, __this){
    var customvalues = [];
    var customvaluesH = [];
    closest.find('.custom_sizes_boxes .input').each(function(i,e){
      customvalues.push($(this).find('input,select').val());    
    });
    var heightval = closest.find('.variant_picker_custom').find('#pdp-height_selector').val();
    var seperate = customvalues
      .join(' x ')
      .split(' x ')
      .map(v => parseFloat(v))
      .filter(v => !isNaN(v)); // safety

    console.log(seperate);
    var l = '', w = '';
    // Find highest & lowest
    if (seperate.length == 1) {
      l = Math.max(...seperate);
    }else if(seperate.length > 0){
      l = Math.max(...seperate);
      w = Math.min(...seperate);
    }
      
    console.log(l,w);
    h = heightval.toLowerCase().trim().replace('inch','');
    var selcolor = closest.find('.variant_picker_custom input.color-swatch-input[type="radio"]').length ? closest.find('.variant_picker_custom input.color-swatch-input[type="radio"]:checked').val() : null;

    if(l == '' || w == ''){
      alert('Please enter dimensions');
      
      // $('.form-info').removeClass('success').addClass('error').html('All fields are mandatory').fadeIn().delay(3000).fadeOut('fast');
      __this.setAttribute('aria-disabled', false);
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      if($('[data-custom-stickyaddtocart]').length > 0){
        $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
        $('[data-custom-stickyaddtocart]').removeClass('loading');
        $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
      }
      return;
      
    } else if (parseInt(l) < 15 || parseInt(w) < 15 || parseInt(l) > 84 || parseInt(w) > 84){
      alert('Please ensure that you have added your dimensions in inches and not in feet/cms');
      // $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions in inches and not in feet/cms').fadeIn().delay(3000).fadeOut('fast');             
      __this.setAttribute('aria-disabled', false);
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      if($('[data-custom-stickyaddtocart]').length > 0){
        $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
        $('[data-custom-stickyaddtocart]').removeClass('loading');
        $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
      }
      return;
      
    } else if (l.toString().includes('.') || w.toString().includes('.')) {
      alert('Please ensure that you have added your dimensions without any decimals');
      // $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions without any decimals.').fadeIn().delay(3000).fadeOut('fast');      
      __this.setAttribute('aria-disabled', false);
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      if($('[data-custom-stickyaddtocart]').length > 0){
        $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
        $('[data-custom-stickyaddtocart]').removeClass('loading');
        $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
      }
      return;
    } else {
      if(l == '' || w == ''){
        __this.setAttribute('aria-disabled', false);
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      if($('[data-custom-stickyaddtocart]').length > 0){
        $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
        $('[data-custom-stickyaddtocart]').removeClass('loading');
        $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
      }
        return;
      }
      var l = parseFloat(l), w = parseFloat(w), h = parseFloat(h);
      var filteredSizeArr,orfilteredSizeArr;
      console.log(allVariants)

      // Step 1: Try exact match
      filteredSizeArr = allVariants.filter(function(v) {
        if (!v.available) return false;

        var opttitle = v.option1+'/'+v.option2;
        let sizeOpt = opttitle.toLowerCase()
          .replaceAll(' ','')
          .replaceAll('inch','')
          .trim();
        let v_len = parseFloat(sizeOpt.split('x')[0].trim());
        let v_width = parseFloat(sizeOpt.split('x')[1].split('/')[0].trim());
        let v_height = parseFloat(sizeOpt.split('x')[1].split('/')[1].trim());

        if(selcolor != null){
          return v_len === l && v_width === w && v_height === h && v.option3 == selcolor;
        }else{
          return v_len === l && v_width === w && v_height === h;
        }

      });

      console.log(filteredSizeArr,'filteredSizeArr')
      // Step 2: If no exact match → find smallest fitting variant
      if (filteredSizeArr.length === 0) {
        let biggerVariants = allVariants.filter(function(v) {
          if (!v.available) return false;
          var opttitle = v.option1+'/'+v.option2;
          let sizeOpt = opttitle.toLowerCase()
            .replaceAll(' ','')
            .replaceAll('inch','')
            .trim();

          let v_len = parseFloat(sizeOpt.split('x')[0].trim());
          let v_width = parseFloat(sizeOpt.split('x')[1].split('/')[0].trim());
          let v_height = parseFloat(sizeOpt.split('x')[1].split('/')[1].trim());

          return v_len >= l && v_width >= w && v_height >= h;
        });

        console.log(biggerVariants,'1111111')

        // Pick the smallest fitting one (minimize over-dimension)
        biggerVariants.sort((a, b) => {
          var aopttitle = a.option1+'/'+a.option2;
          var bopttitle = b.option1+'/'+b.option2;

          let aSize = aopttitle.replaceAll(' ','').replaceAll('inch','').trim().split('x');
          let bSize = bopttitle.replaceAll(' ','').replaceAll('inch','').trim().split('x');

          let a_len = parseFloat(aSize[0]);
          let a_width = parseFloat(aSize[1].split('/')[0]);
          let a_height = parseFloat(aSize[1].split('/')[1]);

          let b_len = parseFloat(bSize[0]);
          let b_width = parseFloat(bSize[1].split('/')[0]);
          let b_height = parseFloat(bSize[1].split('/')[1]);

          // sort by volume difference or dimension difference
          let diffA = (a_len - l) + (a_width - w) + (a_height - h);
          let diffB = (b_len - l) + (b_width - w) + (b_height - h);

          return diffA - diffB;
        });

        console.log(biggerVariants)
        if(selcolor != null){
          biggerVariants = biggerVariants.filter(function(v) {
            return v.option3 == selcolor;
          });
        }
        console.log(biggerVariants)
        filteredSizeArr = biggerVariants.length ? [biggerVariants[0]] : [];

        console.log("Selected Variant:", filteredSizeArr);
        if(filteredSizeArr.length == 0){
          $('.custom-size-form-error').addClass('error').html(window.themesettings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
          return false;
        }
        
        const firstAvailable = filteredSizeArr.find(variant => variant.available === true);
        customhasoriginal = false;
        $('.estimate_delivery_widget .edd-input').attr('data-iscustom',true);
        return firstAvailable;
      }else{
        console.log('elsssssss')
        orfilteredSizeArr = originalallVariants.filter(function(v) {
          if (!v.available) return false;

          var opttitle = v.option1+'/'+v.option2;
          let sizeOpt = opttitle.toLowerCase()
            .replaceAll(' ','')
            .replaceAll('inch','')
            .trim();
          let v_len = parseFloat(sizeOpt.split('x')[0].trim());
          let v_width = parseFloat(sizeOpt.split('x')[1].split('/')[0].trim());
          let v_height = parseFloat(sizeOpt.split('x')[1].split('/')[1].trim());

          if(selcolor != null){
            return v_len === l && v_width === w && v_height === h && v.option3 == selcolor;
          }else{
            return v_len === l && v_width === w && v_height === h;
          }

        });

        if(orfilteredSizeArr.length == 0){
          $('.custom-size-form-error').addClass('error').html(window.themesettings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
          return false;
        }
        
        const firstAvailable = orfilteredSizeArr.find(variant => variant.available === true);        
        customhasoriginal = true;
        $('.estimate_delivery_widget .edd-input').attr('data-iscustom',false);
        return firstAvailable;
      }

      
    }
  }

  $('body').on('click','[data-checkprice]', function(){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    if($(this).closest('[data-stickybar]').length > 0){
      var closest = $(this).closest('product-info').find('.product__info-container');
    }else{
      var closest = $(this).closest('.product__info-container');
    }

    var customsize_variant = findcustomsize_variant(allVariants,closest, __this);

    if(customsize_variant){
      var pricehtml = ``;
      var stickypricehtml = ``;
      if(parseInt(customsize_variant.price) < parseInt(customsize_variant.compare_at_price)){
        var savings = Math.round((((customsize_variant.compare_at_price - customsize_variant.price) * 100.0) / customsize_variant.compare_at_price));
        var saveceilprice = parseInt(customsize_variant.compare_at_price) - parseInt(customsize_variant.price);

          pricehtml += `<div class="mainpricing_wrapper"><div class="price--wrap product-var-price">
              <span class="price-label">M.R.P:</span>
              <span class="money strikthrough">${formatMoneyWithoutTrailingZeros(customsize_variant.compare_at_price)}</span>
            </div>
            
            <div class="price--wrap special--price">
              <span class="price-label">Offer Price:</span>
              <span class="money">
                ${formatMoneyWithoutTrailingZeros(customsize_variant.price)}
              </span>
              <span class="texes-text" style="font-size: 12px;">(Inc. of all taxes)</span>
            </div></div>
          
            <span class="you-save">
              <span class="price-label">You Save</span>
              <span class="saving">
                <span class="saving-result money">
                  ${formatMoneyWithoutTrailingZeros(saveceilprice)}
                </span>
                <span class="save-disc-val">
                  (<span class="you_save_in_percentage">${savings}%</span>)
                </span>
              </span>
            </span>`;
          if($('[data-custom-product-price-list]').attr('data-ppnshow')){
            var product_price_val = (savings * customsize_variant.price) / 100;
            var getSpecialPrice = customsize_variant.price - product_price_val;
            var ppn_price = formatMoneyWithoutTrailingZeros(customsize_variant.price / 3650);
            pricehtml += `<div class="price-per-night">
                <p class="ppn">Price Per Night: ${ppn_price}</p>
              </div>`;
          }
          
          stickypricehtml += `<div class="price--wrap product-var-price">
            <span class="money strikthrough">${formatMoneyWithoutTrailingZeros(customsize_variant.compare_at_price)}</span>
          </div>
          <div class="price--wrap special--price">
            <span class="money">${formatMoneyWithoutTrailingZeros(customsize_variant.price)}</span>
          </div>`;
      }else{
        pricehtml += `<div class="price--wrap special--price">
            <span class="price-label">Offer Price:</span>
            <span class="money">
              ${formatMoneyWithoutTrailingZeros(customsize_variant.price)}
            </span>
            <span class="texes-text" style="font-size: 12px;">(Inc. of all taxes)</span>
          </div>`;

        stickypricehtml += `<div class="price--wrap special--price">
          <span class="money">${formatMoneyWithoutTrailingZeros(customsize_variant.price)}</span>
        </div>`;
      }
      pricehtml += `</div>`;

      closest.find('[data-customsize-button] .desk-price-wrapper').html(`<div class="mobile-price-wrap product-price"><div class="price-container">${pricehtml}</div></div>`);
      $('.mobile-sticky-button .mobile-price-wrap').html(stickypricehtml).show();
      console.log(customsize_variant);

      closest.find('[data-checkprice]').hide();
      closest.find('[data-custom-addtocart]').show();
      
      $('[data-stickybar]').find('[data-checkprice]').hide();
      $('[data-stickybar]').find('[data-custom-stickyaddtocart]').show();
      
      closest.find('.desk-price-wrapper').show();

      __this.setAttribute('aria-disabled', false);
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
    }

  });

  $('body').on('keyup','[data-customsizeinput]', function(){
    var closest = $(this).closest('.product__info-container');
    closest.find('[data-checkprice]').show();
    closest.find('[data-custom-addtocart]').hide();

    $('[data-stickybar]').find('[data-checkprice]').show();
    $('[data-stickybar]').find('[data-custom-stickyaddtocart]').hide();
    $('.estimate_delivery_widget .edd-message').hide().removeClass('edd-success');
  });

  $('body').on('change','.variant_picker_custom [data-pdp-lw_selector]', function(){
    if($('.custom-product-tab').hasClass('active')){
      $('.product__info-container').find('[data-checkprice]').show();
      $('.product__info-container').find('[data-custom-addtocart]').hide();

      $('[data-stickybar]').find('[data-checkprice]').show();
      $('[data-stickybar]').find('[data-custom-stickyaddtocart]').hide();  
      if($(window).width() < 767){
        // $('[data-customsize-button]').hide();
        $('.mobile-sticky-button .mobile-price-wrap').hide();
      }
    }else{
      $('.product__info-container').find('[data-checkprice]').hide();
      $('.product__info-container').find('[data-custom-addtocart]').show();
      $('[data-stickybar]').find('[data-checkprice]').hide();
      $('[data-stickybar]').find('[data-custom-stickyaddtocart]').show();
      if($(window).width() < 767){
        $('[data-custom-addtocart]').show();
        $('.mobile-sticky-button .mobile-price-wrap').show();
      }
    }
    selectvalue($(this).closest('.variant_picker_custom'))
    .then(val => {
        triggerVariantChange(val);
    });
  });

  $('body').on('change','.drawer_rec_options input, .drawer_rec_options select', function(){
    var selector = $(this).closest('.drawer_rec_options');
    var values = [];
    for(var i = 0;i < 3;i++){
      if(selector.find('[data-index="'+i+'"]').length > 0){
        if(selector.find('[data-index="'+i+'"] input[type="radio"]').length > 0){
          values.push(selector.find('[data-index="'+i+'"] input[type="radio"]:checked').val());
        }else{
          values.push(selector.find('[data-index="'+i+'"]').val());
        }
      }
    }
    
    if(values.length > 0){
      if(values.length > 1){
        values = values.join(' / ');  
      }else{
        values = values[0];
      }
      var selectedoption = $(this).closest('form').find('[name="id"] option[data-title="'+values+'"]');
      $(this).closest('form').find('[name="id"]').val(selectedoption.attr('value')).trigger('change');
      var pricehtml = ``;
      if(parseInt(selectedoption.attr('data-price')) < parseInt(selectedoption.attr('data-comp_price'))){
        pricehtml += `<span class="compare">${formatMoneyWithoutTrailingZeros(selectedoption.attr('data-comp_price'))}</span>
                      <span class="price">${formatMoneyWithoutTrailingZeros(selectedoption.attr('data-price'))}</span>`;
      }else{
        pricehtml += `<span class="price">${formatMoneyWithoutTrailingZeros(selectedoption.attr('data-price'))}</span>`;
      }
      $(this).closest('.cart-reco-item').find('.cart-reco-price').html(pricehtml);
      if(selectedoption.attr('data-available') == 'true'){
        console.log('ifff')
        $(this).closest('.cart-reco-item').find('[data-recommandation-atc]').removeAttr('disabled').find('.btn_text').text('Add');
      }else{
        $(this).closest('.cart-reco-item').find('[data-recommandation-atc]').attr('disabled','disabled').find('.btn_text').text('Sold out');
        console.log('elssss')
      }
    }    
  });


  $('body').on('click','.video-product-section .video-card', function(){
    $('html').addClass('no-scroll');
    $('.video_model_custom .model_video_side').each(function() {
      const video = $(this).find('video')[0];
      video.currentTime = 0;   // restart from beginning
      // video.muted = true;
      $(this).find('.mute').hide();
      $(this).find('.unmute').show();
      video.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    });
    $('.videolist_flex').slick('slickGoTo', $(this).attr('data-index'));
    $('.video_model_overlay,.video_model_custom,.video_model_close').addClass('active');

  });

  $('.video-card video').each(function() {
    const video = this;
    const loopStart = 0;   // start time
    const loopEnd = 3;     // end time (3 seconds)

    $(video).on('timeupdate', function() {
      if (video.currentTime >= loopEnd) {
        video.currentTime = loopStart;
        video.play();
      }
    });

    video.currentTime = loopStart;
    video.play();
  });


  $('.videolist_flex').on('init afterChange', function(event, slick, currentSlide){
    // Get current slide index (handle undefined on init)
    var current = currentSlide || 0;

    // Remove old classes
    $(this).find('.slick-slide').removeClass('prev-slide next-slide');

    // Add class to prev slide
    $(this).find('.slick-slide[data-slick-index="' + (current - 1) + '"]').addClass('prev-slide');

    // Add class to next slide
    $(this).find('.slick-slide[data-slick-index="' + (current + 1) + '"]').addClass('next-slide');
    $('.videolist_flex .slick-slide video').each(function() {
      this.muted = true;
      $(this).closest('.model_video_side').find('.mute').hide();
      $(this).closest('.model_video_side').find('.unmute').show();
    });
    var slidevideo = $(this).find('.slick-slide[data-slick-index="' + (current) + '"] video')[0];
    slidevideo.muted = false;
    $(this).find('.slick-slide[data-slick-index="' + (current) + '"] .model_video_side').find('.mute').show();
    $(this).find('.slick-slide[data-slick-index="' + (current) + '"] .model_video_side').find('.unmute').hide();
  });

  $('body').on('click','.video_model_close', function(){
    $('html').removeClass('no-scroll');
    $('.video_model_overlay,.video_model_custom,.video_model_close').removeClass('active');
    $('.videolist_flex .model_video_side video').each(function() {
      this.muted = true;
      $(this).closest('.model_video_side').find('.mute').hide();
      $(this).closest('.model_video_side').find('.unmute').show();
      this.pause();
    });
  });

  $('body').on('click','.videomodel_wrapper.next-slide .model_video_side video,.videomodel_wrapper.prev-slide .model_video_side video', function(){
    $('.videolist_flex').slick('slickGoTo', $(this).closest('.videomodel_wrapper').attr('data-slick-index'));
  });
  $('body').on('click','.contact__buttons_main', function(){
    $(this).addClass('active');
  });

  $(document).on('click', function(e) {
    const $popup = $('.contact__buttons_main.active');
    if ($('.contact__buttons_main.active').is(':visible') && !$popup.is(e.target) && $popup.has(e.target).length === 0) {
      $('.contact__buttons_main.active').removeClass('active');
    }
  });


  $('body').on('click','.model_content_side .item_description,.model_content_side .readmore_btn', function(){
    if($(this).closest('.content_btn_flex').find('.item_description').hasClass('active')){
      $(this).closest('.content_btn_flex').find('.item_description').removeClass('active');
      $(this).closest('.content_btn_flex').find('.readmore_btn').text('Read more');
    }else{
      $(this).closest('.content_btn_flex').find('.item_description').addClass('active');
      $(this).closest('.content_btn_flex').find('.readmore_btn').text('Read less');
    }
    
  });

  $('body').on('click','.mute_video_btn', function() {
    const video = $(this).siblings('video')[0];

    if (video.muted) {
      video.muted = false;
      $(this).find('.mute').show();
      $(this).find('.unmute').hide();
    } else {
      video.muted = true;
      $(this).find('.mute').hide();
      $(this).find('.unmute').show();
    }
  });
  

  $('body').on('change','.variant_picker_custom .unit_selector select', function(){  
    var _this = $(this);
    // $(this).closest('.dimensions_list').find('.measure_link').removeClass('active');
    // $(this).addClass('active');
    $(this).closest('.variant_picker_custom').find('.product_options_sizes').each(function(){      
      $(this).find('select').each(function(i, e){
        $(this).find('option').each(function(i, e){
          if($(e).val() != ''){
            var txtval = $(e).val().toLowerCase().replaceAll(" ", "").replaceAll('inch','').trim();
            if(txtval.indexOf('x') > -1){
              var splittext = txtval.split('x');
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(splittext[0]) / 12;
                var mainval2 = parseInt(splittext[1]) / 12;
                var feetvalue = `${mainval1.toFixed(2)} ft x ${mainval2.toFixed(2)} ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(splittext[0]);
                var mainval2 = 2.54 * parseInt(splittext[1]);
                var feetvalue = `${mainval1.toFixed(2)} cm x ${mainval2.toFixed(2)} cm`;
              }else{
                var mainval1 = parseInt(splittext[0]);
                var mainval2 = parseInt(splittext[1]);
                var feetvalue = `${mainval1} inch x ${mainval2} inch`;
              }
                              
            }else{
              if(_this.val() == 'ft'){
                var mainval1 = parseInt(txtval) / 12;
                var feetvalue = `${mainval1.toFixed(2)} ft`;
              }else if(_this.val() == 'cm'){
                var mainval1 = 2.54 * parseInt(txtval);
                var feetvalue = `${mainval1.toFixed(2)} cm`;
              }else{
                var mainval1 = parseInt(txtval);
                var feetvalue = `${mainval1} inch`;
              }       
            }
            $(e).text(feetvalue); 
          }          
        });
      });
    });
  });

  $('body').on('click','[data-custom-addtocart]', function(evt){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    var closest = $(this).closest('.product__info-container');
    // $('[name="properties[Custom size]"]').remove();
    if(closest.find('.custom-product-tab').hasClass('active')){
      var customvalues = [];
      var customvaluesH = [];
      closest.find('.custom_sizes_boxes .input').each(function(i,e){
        customvalues.push($(this).find('input,select').val());    
      });
      var heightval = closest.find('.variant_picker_custom').find('#pdp-height_selector').val();
      var seperate = customvalues
        .join(' x ')
        .split(' x ')
        .map(v => parseFloat(v))
        .filter(v => !isNaN(v)); // safety

      // Find highest & lowest
      var l = Math.max(...seperate);
      var w = Math.min(...seperate);
      h = heightval.toLowerCase().trim().replace('inch','');
      var selcolor = closest.find('.variant_picker_custom input.color-swatch-input[type="radio"]').length ? closest.find('.variant_picker_custom input.color-swatch-input[type="radio"]:checked').val() : null;
      if(l == '' || w == ''){
        alert('Please enter dimensions');
        // $('.form-info').removeClass('success').addClass('error').html('All fields are mandatory').fadeIn().delay(3000).fadeOut('fast');
        __this.setAttribute('aria-disabled', false);
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
        if($('[data-custom-stickyaddtocart]').length > 0){
          $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
          $('[data-custom-stickyaddtocart]').removeClass('loading');
          $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
        }
        return;
        
      } else if (parseInt(l) < 15 || parseInt(w) < 15 || parseInt(l) > 84 || parseInt(w) > 84){
        alert('Please ensure that you have added your dimensions in inches and not in feet/cms');
        // $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions in inches and not in feet/cms').fadeIn().delay(3000).fadeOut('fast');             
        __this.setAttribute('aria-disabled', false);
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
        if($('[data-custom-stickyaddtocart]').length > 0){
          $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
          $('[data-custom-stickyaddtocart]').removeClass('loading');
          $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
        }
        return;
        
      } else if (l.toString().includes('.') || w.toString().includes('.')) {
        alert('Please ensure that you have added your dimensions without any decimals');
        // $('.form-info').removeClass('success').addClass('error').html('Please ensure that you have added your dimensions without any decimals.').fadeIn().delay(3000).fadeOut('fast');      
        __this.setAttribute('aria-disabled', false);
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
        if($('[data-custom-stickyaddtocart]').length > 0){
          $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
          $('[data-custom-stickyaddtocart]').removeClass('loading');
          $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
        }
        return;
      } else {
        if(l == '' || w == ''){
          __this.setAttribute('aria-disabled', false);
          $(__this).removeClass('loading');
          $(__this).find('.loading__spinner').addClass('hidden');
          if($('[data-custom-stickyaddtocart]').length > 0){
            $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
            $('[data-custom-stickyaddtocart]').removeClass('loading');
            $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
          }
          return;
        }
        var l = parseFloat(l), w = parseFloat(w), h = parseFloat(h);
        var filteredSizeArr;
        
        if(customhasoriginal){
          updatedallVariants = originalallVariants;
        }else{
          updatedallVariants = allVariants;
        }
        console.log(updatedallVariants)
        // Step 1: Try exact match
        filteredSizeArr = updatedallVariants.filter(function(v) {
          if (!v.available) return false;

          var opttitle = v.option1+'/'+v.option2;
          let sizeOpt = opttitle.toLowerCase()
            .replaceAll(' ','')
            .replaceAll('inch','')
            .trim();

          let v_len = parseFloat(sizeOpt.split('x')[0].trim());
          let v_width = parseFloat(sizeOpt.split('x')[1].split('/')[0].trim());
          let v_height = parseFloat(sizeOpt.split('x')[1].split('/')[1].trim());
          
          if(selcolor != null){
            return v_len === l && v_width === w && v_height === h && v.option3 == selcolor;
          }else{
            return v_len === l && v_width === w && v_height === h;
          }
        });

        // Step 2: If no exact match → find smallest fitting variant
        if (filteredSizeArr.length === 0) {
          let biggerVariants = updatedallVariants.filter(function(v) {
            if (!v.available) return false;

            var opttitle = v.option1+'/'+v.option2;
            let sizeOpt = opttitle.toLowerCase()
              .replaceAll(' ','')
              .replaceAll('inch','')
              .trim();

            let v_len = parseFloat(sizeOpt.split('x')[0].trim());
            let v_width = parseFloat(sizeOpt.split('x')[1].split('/')[0].trim());
            let v_height = parseFloat(sizeOpt.split('x')[1].split('/')[1].trim());

            return v_len >= l && v_width >= w && v_height >= h;
          });

          // Pick the smallest fitting one (minimize over-dimension)
          biggerVariants.sort((a, b) => {
            var aopttitle = a.option1+'/'+a.option2;
            var bopttitle = b.option1+'/'+b.option2;

            let aSize = aopttitle.replaceAll(' ','').replaceAll('inch','').trim().split('x');
            let bSize = bopttitle.replaceAll(' ','').replaceAll('inch','').trim().split('x');

            let a_len = parseFloat(aSize[0]);
            let a_width = parseFloat(aSize[1].split('/')[0]);
            let a_height = parseFloat(aSize[1].split('/')[1]);

            let b_len = parseFloat(bSize[0]);
            let b_width = parseFloat(bSize[1].split('/')[0]);
            let b_height = parseFloat(bSize[1].split('/')[1]);

            // sort by volume difference or dimension difference
            let diffA = (a_len - l) + (a_width - w) + (a_height - h);
            let diffB = (b_len - l) + (b_width - w) + (b_height - h);

            return diffA - diffB;
          });

          console.log(biggerVariants)
          if(selcolor != null){
            biggerVariants = biggerVariants.filter(function(v) {
              console.log(v);
              return v.option3 == selcolor;
            });
          }
          console.log(biggerVariants)

          filteredSizeArr = biggerVariants.length ? [biggerVariants[0]] : [];
        }

        console.log("Selected Variant:", filteredSizeArr);
        if(filteredSizeArr.length == 0){
          $('.custom-size-form-error').addClass('error').html(window.themesettings.sizenotfound).fadeIn().delay(3000).fadeOut('fast');      
          return false;
        }
       
        const firstAvailable = filteredSizeArr.find(variant => variant.available === true);
        closest.find('[name="id"]').val(firstAvailable.id);
        // $(__this).closest('[data-type="customform"]')
        //   .append(`<input type="hidden" class="removable" name="properties[Custom Size]" value="${l} inch x ${w} inch / ${h} inch">
        //   <input type="hidden" class="removable" name="properties[Length Size]" value="${l} inch">
        //   <input type="hidden" class="removable" name="properties[Breadth Size]" value="${w} inch">
        //   <input type="hidden" class="removable" name="properties[Height Size]" value="${h} inch">
        //   `);
        if(!customhasoriginal){
          $(__this).closest('[data-type="customform"]')
            .append(`<input type="hidden" class="removable" name="properties[Length Size]" value="${l} inch">
            <input type="hidden" class="removable" name="properties[Breadth Size]" value="${w} inch">
            <input type="hidden" class="removable" name="properties[Height Size]" value="${h} inch">
            `);
        }
      }
    }
    
    var form = closest.find('[data-type="customform"]').get(0);
    var drawercart = document.querySelector('cart-drawer'); 
    const formData = new FormData(form);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    console.log(drawercart);
    delete config.headers['Content-Type'];
    if (drawercart) {
      formData.append(
        'sections',
        drawercart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      drawercart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
        CartPerformance.measure("add:paint-updated-sections", () => {
          drawercart.renderContents(response);
        });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      __this.setAttribute('aria-disabled', false);
      if (drawercart && drawercart.classList.contains('is-empty')) drawercart.classList.remove('is-empty');
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      if($('[data-custom-stickyaddtocart]').length > 0){
        $('[data-custom-stickyaddtocart]').attr('aria-disabled', false);
        $('[data-custom-stickyaddtocart]').removeClass('loading');
        $('[data-custom-stickyaddtocart]').find('.loading__spinner').addClass('hidden');  
      }
      $(__this).closest('[data-type="customform"]').find('.removable').remove();
      // Optional: measure user action
      CartPerformance.measureFromEvent("add:user-action", evt);
    });    
    
  });

  $('body').on('click', '.drawer-menu-submenu .submenu_link', function(e) {

    let $parent = $(this).closest(".drawer-menu-submenu");

    if ($parent.hasClass("active")) {
      // Close current submenu
      $parent.removeClass("active").find(".submenu_content").slideUp();
    } else {
      // Close all other submenus
      $(".drawer-menu-submenu").removeClass("active").find(".submenu_content").slideUp();

      // Open the clicked submenu
      $parent.addClass("active").find(".submenu_content").slideDown();
    }
  });

  $("body").on('click','.testionial-content-slider .view-more_button_wp a,.plp-review-item-button', function(e){
    e.preventDefault();
    $('.loox-float-toggler').trigger('click');
  });

  if($('.faq-button.showmore').length > 0){
    $("body").on("click",'.faq-button.showmore', function(){
      $(this).toggleClass("active");
      console.log($(this).closest('.faq-custom-section').find(".morecontent").length);
      $(this).closest('.faq-custom-section').find(".morecontent").slideToggle();
    
      if ($(this).hasClass("active")) {
        $(".btn-text").html("show less");
      } else {
        $(".btn-text").html("show more");
      }
    });
  }
  

  if($('#BlogTagFilter').length > 0){
    var $filterBy = $('#BlogTagFilter');

    if (!$filterBy.length) {
      return;
    }

    $filterBy.on('change', function() {
      location.href = $(this).val();
    });
  }

  $('body').on('click','[data-stickybar] [data-custom-stickyaddtocart]', function(){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    $(this).closest('product-info').find('[data-custom-addtocart]').trigger('click');
  });
  
  $('body').on('click','[data-type="card-customform"] .card-addtocart', function(evt){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    
    var form = $(this).closest('[data-type="card-customform"]').get(0);
    var drawercart = document.querySelector('cart-drawer'); 
    const formData = new FormData(form);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    console.log(drawercart);
    delete config.headers['Content-Type'];
    if (drawercart) {
      formData.append(
        'sections',
        drawercart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      drawercart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
        CartPerformance.measure("add:paint-updated-sections", () => {
          drawercart.renderContents(response);
        });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      __this.setAttribute('aria-disabled', false);
      if (drawercart && drawercart.classList.contains('is-empty')) drawercart.classList.remove('is-empty');
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      // Optional: measure user action
      CartPerformance.measureFromEvent("add:user-action", evt);
    });
  });

  $('body').on('click','[data-recommandation-atc]', function(evt){
    var __this = this;
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');
    
    var form = $(this).closest('[data-type="card-customform"]').get(0);
    var drawercart = document.querySelector('cart-drawer'); 
    const formData = new FormData(form);
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    console.log(drawercart);
    delete config.headers['Content-Type'];
    if (drawercart) {
      formData.append(
        'sections',
        drawercart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      drawercart.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {

      const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
        CartPerformance.measure("add:paint-updated-sections", () => {
          drawercart.renderContents(response);
        });
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      __this.setAttribute('aria-disabled', false);
      if (drawercart && drawercart.classList.contains('is-empty')) drawercart.classList.remove('is-empty');
      $(__this).removeClass('loading');
      $(__this).find('.loading__spinner').addClass('hidden');
      // Optional: measure user action
      CartPerformance.measureFromEvent("add:user-action", evt);
    });
  });

  $('body').on('click','.measuring_size a',function(e){
    e.preventDefault();
    $('.measuring_video').addClass('active').show();
  });
  $('.close-popup').click(function(){
    $(this).parent('.measuring_video').removeClass('active').hide();
  });

  $('body').on('click','.content-tabs-wrapper .tab-link', function(){
    $(this).closest('.tabs-nav').find('.tab-link').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.content-tabs-wrapper').find('.tab-content,.tab-img').hide();
    $(this).closest('.content-tabs-wrapper').find('[data-tab="'+$(this).attr('data-tab')+'"]').show();
  });

  $('body').on('change','.card-product_custom .item_options_selector input,.card-product_custom .item_options_selector select', function(){
    var _this = $(this);
    console.log(_this);
    var vararry = [];
    for(var i = 0;i <= 2;i++){
      if(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').length > 0){      
        if(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').find('input[type="radio"]').length > 0){
          vararry.push(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').find('input[type="radio"]:checked').val());
        }else{
          vararry.push(_this.closest('.card_form_wrapper').find('[data-option-index="'+i+'"]').find('select').val());  
        }
        
      }
    }
    var vartitle = vararry.join(' / ');
    var prddata = JSON.parse(_this.closest('.card-product_custom').find('.productJson').html());
    console.log(prddata)
    var selectedvariant = prddata.product.variants.filter(function(v){
      return v.title == vartitle;          
    });
    console.log(selectedvariant)
    var pricehtml = '<div class="price__sale">';
    if(selectedvariant[0].price < selectedvariant[0].compare_at_price){
      pricehtml += `<span>
        <s class="price-item price-item--regular">
          ${formatMoneyWithoutTrailingZeros(selectedvariant[0].compare_at_price)}  
        </s>
      </span>`;
    }
    pricehtml += `<span class="price-item price-item--sale price-item--last">
        ${formatMoney(selectedvariant[0].price, currencyFormat)}
      </span>`;
    _this.closest('.card-product_custom').find('.card-information .price').addClass('price--on-sale');
    _this.closest('.card-product_custom').find('.card-information .price').html(pricehtml);
    _this.closest('.card-product_custom').find('[name="id"]').val(selectedvariant[0].id);
  });

  // $('body').on('change','.cart-coupon_offer-input [name="discount_code"]', function(){
  //     $(this).closest('.cart-coupon_offer-input').find('#coupon_code_input').val($(this).val()).closest('.cart-coupon_offer-input').find('[data-inputapply]').removeAttr('disabled').trigger('click');
  // });

  $('body').on('keyup','.cart-drawer #coupon_code_input', function(){
    console.log('innn')
    if($(this).val() != ''){
      $(this).closest('.cart-drawer').find('[data-inputapply]').removeAttr('disabled');  
    }else{
      $(this).closest('.cart-drawer').find('[data-inputapply]').attr('disabled','disabled');
    }
    
  });

  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.cart-drawer').find('.cart-discount__pill');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }  
    return discountCodes;
  }
  
  $('body').on('click', '.cart-drawer [data-inputapply]', function () {
    $('.offer_input_err').remove();
    var _this = $(this);
    var sectionId = _this.closest('cart-drawer').attr('section');
    var drawercart = document.querySelector('cart-drawer');
    var discountCodeValue = _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val();
  
    if (discountCodeValue === '') {
      _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
    if (discountCodeValue == 'none') {
      _this.closest('.cart-coupon_offer-input').find('#coupon_code_input').val('');
    }

    _this.addClass('loading');
    _this.find('.loading__spinner').removeClass('hidden');
  
    var existingDiscountsValue = existingDiscounts();    
    
    if (existingDiscountsValue.includes(discountCodeValue)){
      _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Code is already applied.</p>');
      _this.removeClass('loading');
      _this.find('.loading__spinner').addClass('hidden');
      return;
    }
    async function getupdatedata() {
      let response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: drawercart.getSectionsToRender().map((section) => section.section)
        })
      });
      return await response.json();
    }
  
    function getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  
    getupdatedata().then(data => {
      console.log(data);
      // const parsedState = JSON.parse(data);
      if (data.discount_codes.find(discount => discount.code === discountCodeValue && !discount.applicable)) {
        _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Discount code cannot be applied to your cart</p>');
        _this.removeClass('loading');
        _this.find('.loading__spinner').addClass('hidden');
        return;
      }

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items','.cart_extras', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  
      _this.removeClass('loading');
      _this.find('.loading__spinner').addClass('hidden');
    }).catch(error => {
      console.error('Error updating cart:', error);
      _this.removeClass('loading');
      _this.find('.loading__spinner').addClass('hidden');
    });
  
  });

  $('body').on('click','[data-removecode]', function(){

    var _this = $(this);
    _this.addClass('loading');
    _this.find('.loading__spinner').removeClass('hidden');
    var sectionId = _this.closest('cart-drawer').attr('section');
    var drawercart = document.querySelector('cart-drawer');
    var discountCodeValue = _this.attr('data-code');
    console.log(discountCodeValue)
    var existingDiscountsValue = existingDiscounts();
    
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    async function getupdatedata(){     
      let response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          discount: existingDiscountsValue.join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }

    function getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    
    getupdatedata().then(data => {
      console.log(data);
      // const parsedState = JSON.parse(data);
      if (data.discount_codes.find(discount => discount.code === discountCodeValue && !discount.applicable)) {
        _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Discount code cannot be applied to your cart</p>');
        _this.removeClass('loading');
        _this.find('.loading__spinner').addClass('hidden');
        return;
      }

      fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items','.cart_extras', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  
      // _this.removeClass('loading');
      // _this.find('.loading__spinner').addClass('hidden');
    }).catch(error => {
      console.error('Error updating cart:', error);
      // _this.removeClass('loading');
      // _this.find('.loading__spinner').addClass('hidden');
    });
  });

  

  // FAQ
  $('body').on('click','.faq-custom-accordion-title', function(){
    var activeTitle = $(this);
    // Close other FAQs
    $(".faq-custom-accordion-title").not(activeTitle).removeClass("active").next(".faq-custom-accordion-body").slideUp();
    // Toggle current one
    activeTitle.toggleClass("active").next(".faq-custom-accordion-body").slideToggle();
  });

  $('body').on('click','.toggle-button', function(){
    $(this).next().slideToggle();
    $(this).toggleClass('active');
  });

  $('body').on('click','.footer-bottom-links .footer-button-wp', function(){
    $(this).closest('.footer-bottom-links').find('.links-content-main').slideToggle();
  });

  $('.custom-image-overlay-slider').slick({
    draggable: true,
    fade: false,
    arrows: true,
    infinite: false
  });

  if ($(window).width() < 769) {
    $('.better-sleep-blocks').slick({
      dots: false,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            arrows: false
          }
        }
      ]
    });
  }

  if ($('.plp-review-sec-list').find('.plp-review-sec-item').length > 4) {
    $('.plp-review-sec-list').slick({
      dots: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 2,
            dots : false,
            autoplaySpeed: 5000,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots : false,
            autoplaySpeed: 5000
          }
        }
      ]
    });
  }

  // TYPE OF MATTERSSES
  // On Click From Open
  $("body").on("click",".btn_show_form", function(){
    $(this).css("display", "none")
    $(this).next(".type-of-mat-size_and__ATC").css("display", "block");
  })

  // Get dummy Dropdown value
  $("body").on("change",".type-of-mat-size_and__ATC .option-Size", function(){
    var optionSelected = $(this).find("option:selected");
    var valueSelected  = optionSelected.val();
    var textSelected   = optionSelected.text();
    var dataTitle = $(this).attr('data-title');
    var combinedOption = dataTitle + " / " + valueSelected;
    $(`.master-selector option:contains(${combinedOption})`).prop("selected","selected");
    var variantPrice = $(".master-selector").find("option:selected").attr("variant-price");    
    $(this).closest('.type-of-mat-itm-inr').find(".type-of-mat-itm-pro-price span").html(variantPrice);
    console.log('dataTitle',dataTitle);
    console.log('optionSelected',optionSelected);
  })

  // Add to cart 
  $('body').on('click', '#type-of-mat-addToCart', function(evt) {
    const __this = this;
  
    __this.setAttribute('aria-disabled', true);
    $(__this).addClass('loading');
    $(__this).find('.loading__spinner').removeClass('hidden');

    const form = $(this).closest('.type-of-mat-size_and__ATC').get(0);
    const drawercart = document.querySelector('cart-drawer');
    const optionId = $(__this).next('.master-selector').find('option:selected').val();
  
    const formData = new FormData(form);
  
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
  
    if (drawercart) {
      formData.append(
        'sections',
        drawercart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      drawercart.setActiveElement(document.activeElement);
    }
  
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
  
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: optionId,
          cartData: response,
        }).then(() => {
          CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
        });
  
        CartPerformance.measure('add:paint-updated-sections', () => {
          if (drawercart) drawercart.renderContents(response);
        });
      })
      .catch((e) => {
        console.error('Add to cart failed', e);
      })
      .finally(() => {
        __this.setAttribute('aria-disabled', false);
        if (drawercart && drawercart.classList.contains('is-empty')) drawercart.classList.remove('is-empty');
        $(__this).removeClass('loading');
        $(__this).find('.loading__spinner').addClass('hidden');
  
        CartPerformance.measureFromEvent('add:user-action', evt);
      });
  });
  
  // Tab function
  $('.the-facts_tag-header_item-title ').click(function(e){
      e.preventDefault
    $('.the-facts_tag-header_item').removeClass('active');
    $(this).parents('.the-facts_tag-header_item').addClass('active');
    $('.the-facts_tag-content-item').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $('body').on('click','.the-facts_tag-header_item .prev-arrow', function(){
    $(this).closest('.the-facts_tag-header_item').removeClass('active');
    $(this).closest('.the-facts_tag-header_item').prev().addClass('active').find('.the-facts_tag-header_item-title').trigger('click');
  });
  $('body').on('click','.the-facts_tag-header_item .next-arrow', function(){
    $(this).closest('.the-facts_tag-header_item').removeClass('active');
    $(this).closest('.the-facts_tag-header_item').next().addClass('active').find('.the-facts_tag-header_item-title').trigger('click');
  });

  if($(".mobile-sticky-button").length > 0 && $(window).width() < 767){
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        $(".mobile-sticky-button").addClass('active');
      } else {
        $(".mobile-sticky-button").removeClass('active');
      }
    });
  }

  $('body').on('click','.menu-drawer-container .close-icon',function(e){
    $(this).closest('.menu-drawer-container').find('[aria-controls="menu-drawer"]').trigger('click');
  });

  $('body').on('keyup', '.estimate_delivery_widget .edd-input', function () {
    var $widget = $(this).closest('.edd-widget');
    var $msg = $widget.find('.edd-message');
    $msg.hide().removeClass('edd-error');
  });

  $('body').on('click', '.estimate_delivery_widget .edd-btn:not(.change__to_reset)', function () {
    var $button = $(this);
    $button.addClass('loading');
    var $widget = $(this).closest('.edd-widget');
    var $input = $widget.find('.edd-input');
    var pincode = $input.val().trim();
    var $msg = $widget.find('.edd-message');
    $msg.hide();
    
    var variantId = $input.attr('data-currentvid');
    var iscustom = $input.attr('data-iscustom');

    if (!/^\d{6}$/.test(pincode)) {
      $msg.show().text($msg.attr('data-errmsg'))
          .removeClass('edd-success')
          .addClass('edd-error');
      $button.removeClass('loading');  
      return;
    }

    $widget.find('.widget_text').text(`Checking delivery to ${pincode}…`);
    $widget.addClass('edd-loader');
    
    $msg.text("");

    try {
      async function getupdatedata() {
        const url = `https://external.flomattress.in/api/logistics/get-expected-tat?pincode=${pincode}&variantId=${variantId}&isCustom=${iscustom}`;

        let response = await fetch(url, {
          method: "GET",
          headers: { 
            "x-api-key": "25ffe5dc88ac1aeb9a259a2bc57b477926db460684627e63cf186fd7a65737bc",
            "x-agent-email": "shopify@flomattress.in" 
          }
        });

        return await response.json();
      }

      getupdatedata().then(data => {
        console.log(data);
        if(data.success){
          // 👉 Calculate ETA (4th to 7th day)
          var today = new Date();

          var day4 = new Date(today);
          day4.setDate(today.getDate() + data.data.totalTat);

          var day7 = new Date(today);
          day7.setDate(today.getDate() + 7);

          function formatDate(date) {
            const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
            const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

            const dayName = days[date.getDay()];
            const day = date.getDate();
            const month = months[date.getMonth()];

            function getSuffix(d) {
              if (d > 3 && d < 21) return 'th';
              switch (d % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
              }
            }

            return `${dayName}, ${day}${getSuffix(day)} ${month}`;
          }

          $widget.find('.widget_text').text(`Delivering to ${pincode}`);

          var etaText = formatDate(day4);
          var msghtml = `Get it by ${etaText}`;

          $widget.find('.edd-input').val(msghtml).attr('readonly');
          $button.removeClass('loading').addClass('change__to_reset').find('.btntext').text('CHANGE');

        }else{
          $msg.show().text(data.message)
          .removeClass('edd-success')
          .addClass('edd-error');
          $button.removeClass('loading');  
          $widget.find('.widget_text').text($widget.find('.widget_text').attr('data-defaulttext'));
        }
      });

    } catch (e) {
      $msg.text("Error occurred")
          .removeClass('edd-success')
          .addClass('edd-error');
      $button.removeClass('loading');  
      $widget.find('.widget_text').text($widget.find('.widget_text').attr('data-defaulttext'));
    }

  });

  $('body').on('click', '.estimate_delivery_widget .edd-btn.change__to_reset', function () {
    var $button = $(this);
    $button.addClass('loading');
    var $widget = $(this).closest('.edd-widget');
    var $input = $widget.find('.edd-input');
    $widget.find('.widget_text').text($widget.find('.widget_text').attr('data-defaulttext'));
    $input.val('');
    $button.removeClass('loading').find('.btntext').text('Check');
    $button.removeClass('change__to_reset');
  });


  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    var cart = event.cartData;
    console.log(cart);
    console.log('ojijijijijij');
    if(cart.items){
      var notetext = '';
      $(cart.items).each(function(i,e){
        if(e.properties['Breadth Size'] != undefined && e.properties['Height Size'] != undefined && e.properties['Length Size'] != undefined){
          notetext += `[SKU = ${e.sku} || Length - ${e.properties['Length Size']} || Breadth - ${e.properties['Breadth Size']} || Height - ${e.properties['Height Size']} ]`;
        }
      });
      fetch(`/cart/update.js`, {
        body: JSON.stringify({ note: notetext }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
    }else{
      $.getJSON('/cart.js', function(cart){
        var notetext = '';
        $(cart.items).each(function(i,e){
          if(e.properties['Breadth Size'] != undefined && e.properties['Height Size'] != undefined && e.properties['Length Size'] != undefined){
            notetext += `[SKU = ${e.sku} || Length - ${e.properties['Length Size']} || Breadth - ${e.properties['Breadth Size']} || Height - ${e.properties['Height Size']}]`;
          }
        });
        fetch(`/cart/update.js`, {
          body: JSON.stringify({ note: notetext }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        });
      });
    }
    
  });

  if(window.themesettings.enable_widegt){
    setTimeout(function(){
      if (Weglot && document.getElementById("myweglotDiv")) {
        var myDiv = document.getElementById("myweglotDiv");
        //Create array of options to be added
        var availableLanguages = Weglot.options.languages
            .map(function(language) {
                return language.language_to;
            })
            .concat(Weglot.options.language_from);
        
        //Create and append select list
        var showlanglist = document.createElement("ul");
        showlanglist.className = "lang_list_animation";
    
        myDiv.appendChild(showlanglist);
        
        var currentLang = Weglot.getCurrentLang();
        var langlist = ``;
          console.log(availableLanguages);
        //Create and append the options
        for (var i = 0; i < availableLanguages.length; i++) {
            var lang = availableLanguages[i];
            if (lang === currentLang) {
              langlist += `<li class="selected" data-val="${lang}">
                  <span class=""lantext">${Weglot.getLanguageName(lang)}</span>
                  <span class="svg_icon"><svg width="25" height="25" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9297 15.9375C10.3776 15.9375 9.83854 15.8802 9.3125 15.7656C8.79167 15.651 8.29167 15.4896 7.8125 15.2812C7.92708 15.1406 8.03385 14.9948 8.13281 14.8438C8.23698 14.6979 8.33073 14.5443 8.41406 14.3828C8.51302 14.4245 8.61198 14.4635 8.71094 14.5C8.8151 14.5365 8.92188 14.5677 9.03125 14.5938C8.85938 14.4427 8.70833 14.2552 8.57812 14.0312C8.67188 13.8177 8.75 13.599 8.8125 13.375C8.88021 13.151 8.92969 12.9245 8.96094 12.6953C9.3724 13.5964 9.85677 14.1693 10.4141 14.4141V11.9375C10.1641 11.9479 9.92188 11.9635 9.6875 11.9844C9.45312 12.0052 9.22396 12.0339 9 12.0703C9 11.8932 8.98958 11.7188 8.96875 11.5469C8.95312 11.375 8.92708 11.2135 8.89062 11.0625C9.13542 11.026 9.38542 10.9948 9.64062 10.9688C9.89583 10.9375 10.1536 10.9193 10.4141 10.9141V8.47656H7.4375C7.22396 8.26823 6.99219 8.07812 6.74219 7.90625C6.4974 7.73438 6.23698 7.58333 5.96094 7.45312H6.99219C7.00781 6.92708 7.04948 6.42188 7.11719 5.9375C7.1901 5.45312 7.28385 4.99219 7.39844 4.55469C6.64844 4.32031 6.03646 4.02083 5.5625 3.65625C5.18229 4.13021 4.86198 4.65365 4.60156 5.22656C4.34635 5.79948 4.17708 6.40104 4.09375 7.03125C3.96354 7.02083 3.78646 7.02604 3.5625 7.04688C3.34375 7.0625 3.16146 7.08594 3.01562 7.11719C3.11979 6.1224 3.39583 5.19531 3.84375 4.33594C4.29688 3.47656 4.88021 2.72135 5.59375 2.07031C6.3125 1.41927 7.125 0.911458 8.03125 0.546875C8.9375 0.182292 9.90104 0 10.9219 0C12.0104 0 13.0339 0.208333 13.9922 0.625C14.9557 1.04167 15.8047 1.61719 16.5391 2.35156C17.2734 3.08594 17.849 3.9349 18.2656 4.89844C18.6875 5.85677 18.8984 6.88021 18.8984 7.96875C18.8984 9.05729 18.6901 10.0833 18.2734 11.0469C17.8568 12.0052 17.2812 12.8516 16.5469 13.5859C15.8125 14.3203 14.9635 14.8958 14 15.3125C13.0417 15.7292 12.0182 15.9375 10.9297 15.9375ZM6.25 2.91406C6.45312 3.04948 6.67448 3.17708 6.91406 3.29688C7.15365 3.41146 7.41406 3.51302 7.69531 3.60156C7.8724 3.11719 8.07552 2.6849 8.30469 2.30469C8.53385 1.92448 8.78125 1.60417 9.04688 1.34375C8.52083 1.48438 8.02083 1.6901 7.54688 1.96094C7.07812 2.22656 6.64583 2.54427 6.25 2.91406ZM8.70312 3.85938C8.96875 3.90625 9.24219 3.94531 9.52344 3.97656C9.8099 4.00781 10.1068 4.02865 10.4141 4.03906V1.53125C10.0807 1.67188 9.76562 1.94792 9.46875 2.35938C9.17188 2.76562 8.91667 3.26562 8.70312 3.85938ZM11.4375 4.03906C11.7448 4.02865 12.0417 4.00781 12.3281 3.97656C12.6146 3.94531 12.888 3.90625 13.1484 3.85938C12.9349 3.26562 12.6797 2.76562 12.3828 2.35938C12.0911 1.94792 11.776 1.67188 11.4375 1.53125V4.03906ZM14.1562 3.60156C14.724 3.42448 15.2031 3.19531 15.5938 2.91406C15.2083 2.54948 14.7786 2.23438 14.3047 1.96875C13.8359 1.69792 13.3359 1.48958 12.8047 1.34375C13.0755 1.60417 13.3255 1.92708 13.5547 2.3125C13.7839 2.69271 13.9844 3.1224 14.1562 3.60156ZM8.03125 7.45312H10.4141V5.0625C10.0651 5.05208 9.72135 5.02604 9.38281 4.98438C9.04427 4.94271 8.71875 4.89062 8.40625 4.82812C8.30729 5.22396 8.22396 5.64323 8.15625 6.08594C8.09375 6.52865 8.05208 6.98438 8.03125 7.45312ZM11.4375 7.45312H13.8203C13.8047 6.98438 13.763 6.52865 13.6953 6.08594C13.6328 5.64323 13.5495 5.22396 13.4453 4.82812C13.1328 4.89062 12.8073 4.94271 12.4688 4.98438C12.1354 5.02604 11.7917 5.05208 11.4375 5.0625V7.45312ZM14.8672 7.45312H17.8125C17.7604 6.74479 17.6016 6.06771 17.3359 5.42188C17.0703 4.77604 16.7214 4.1901 16.2891 3.66406C15.8047 4.02344 15.1927 4.32031 14.4531 4.55469C14.5729 4.99219 14.6667 5.45312 14.7344 5.9375C14.8021 6.42188 14.8464 6.92708 14.8672 7.45312ZM11.4375 10.9141C11.7917 10.9245 12.1354 10.9505 12.4688 10.9922C12.8021 11.0339 13.125 11.0859 13.4375 11.1484C13.5417 10.7422 13.6276 10.3151 13.6953 9.86719C13.763 9.41927 13.8047 8.95573 13.8203 8.47656H11.4375V10.9141ZM14.4531 11.4141C15.1927 11.6484 15.7995 11.9453 16.2734 12.3047C16.7057 11.7734 17.0573 11.1849 17.3281 10.5391C17.599 9.88802 17.7604 9.20052 17.8125 8.47656H14.8672C14.8464 9.01302 14.8021 9.52865 14.7344 10.0234C14.6667 10.513 14.5729 10.9766 14.4531 11.4141ZM11.4375 14.4141C11.776 14.2682 12.0885 13.9948 12.375 13.5938C12.6667 13.1927 12.9219 12.7005 13.1406 12.1172C12.6354 12.0234 12.0677 11.9635 11.4375 11.9375V14.4141ZM12.8203 14.5938C13.3359 14.4479 13.8255 14.2422 14.2891 13.9766C14.7578 13.7109 15.1849 13.3984 15.5703 13.0391C15.1953 12.7786 14.7214 12.5573 14.1484 12.375C13.9766 12.8385 13.7786 13.2578 13.5547 13.6328C13.3307 14.013 13.0859 14.3333 12.8203 14.5938ZM3.96875 16.0234C3.42708 16.0234 2.91667 15.9193 2.4375 15.7109C1.95833 15.5078 1.53646 15.224 1.17188 14.8594C0.807292 14.4948 0.520833 14.0729 0.3125 13.5938C0.104167 13.1146 0 12.6016 0 12.0547C0 11.5078 0.104167 10.9974 0.3125 10.5234C0.520833 10.0443 0.807292 9.6224 1.17188 9.25781C1.53646 8.88802 1.95833 8.60156 2.4375 8.39844C2.91667 8.1901 3.42708 8.08594 3.96875 8.08594C4.51562 8.08594 5.02865 8.1901 5.50781 8.39844C5.98698 8.60156 6.40885 8.88542 6.77344 9.25C7.13802 9.61458 7.42188 10.0365 7.625 10.5156C7.83333 10.9948 7.9375 11.5078 7.9375 12.0547C7.9375 12.5964 7.83333 13.1068 7.625 13.5859C7.41667 14.0651 7.1276 14.487 6.75781 14.8516C6.39323 15.2161 5.97135 15.5026 5.49219 15.7109C5.01302 15.9193 4.50521 16.0234 3.96875 16.0234ZM4.85156 14.4141C4.9401 14.3307 4.98438 14.224 4.98438 14.0938C4.98438 13.9688 4.9375 13.862 4.84375 13.7734L3.02344 12.0625L4.84375 10.3516C4.93229 10.263 4.97396 10.1562 4.96875 10.0312C4.96875 9.90625 4.92188 9.79948 4.82812 9.71094C4.74479 9.63281 4.64323 9.59635 4.52344 9.60156C4.40885 9.60156 4.30469 9.64583 4.21094 9.73438L2.21875 11.6094C2.06771 11.7552 1.99479 11.9115 2 12.0781C2.01042 12.2448 2.08333 12.3932 2.21875 12.5234L4.21094 14.3984C4.29948 14.4818 4.40625 14.5234 4.53125 14.5234C4.66146 14.5286 4.76823 14.4922 4.85156 14.4141Z" fill="#EBF2FA"/></svg>
                </span>
              </li>`;
            }else{
              langlist += `<li data-val="${lang}">
                  <span class=""lantext">${Weglot.getLanguageName(lang)}</span>
                  <span class="svg_icon"><svg width="25" height="25" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9297 15.9375C10.3776 15.9375 9.83854 15.8802 9.3125 15.7656C8.79167 15.651 8.29167 15.4896 7.8125 15.2812C7.92708 15.1406 8.03385 14.9948 8.13281 14.8438C8.23698 14.6979 8.33073 14.5443 8.41406 14.3828C8.51302 14.4245 8.61198 14.4635 8.71094 14.5C8.8151 14.5365 8.92188 14.5677 9.03125 14.5938C8.85938 14.4427 8.70833 14.2552 8.57812 14.0312C8.67188 13.8177 8.75 13.599 8.8125 13.375C8.88021 13.151 8.92969 12.9245 8.96094 12.6953C9.3724 13.5964 9.85677 14.1693 10.4141 14.4141V11.9375C10.1641 11.9479 9.92188 11.9635 9.6875 11.9844C9.45312 12.0052 9.22396 12.0339 9 12.0703C9 11.8932 8.98958 11.7188 8.96875 11.5469C8.95312 11.375 8.92708 11.2135 8.89062 11.0625C9.13542 11.026 9.38542 10.9948 9.64062 10.9688C9.89583 10.9375 10.1536 10.9193 10.4141 10.9141V8.47656H7.4375C7.22396 8.26823 6.99219 8.07812 6.74219 7.90625C6.4974 7.73438 6.23698 7.58333 5.96094 7.45312H6.99219C7.00781 6.92708 7.04948 6.42188 7.11719 5.9375C7.1901 5.45312 7.28385 4.99219 7.39844 4.55469C6.64844 4.32031 6.03646 4.02083 5.5625 3.65625C5.18229 4.13021 4.86198 4.65365 4.60156 5.22656C4.34635 5.79948 4.17708 6.40104 4.09375 7.03125C3.96354 7.02083 3.78646 7.02604 3.5625 7.04688C3.34375 7.0625 3.16146 7.08594 3.01562 7.11719C3.11979 6.1224 3.39583 5.19531 3.84375 4.33594C4.29688 3.47656 4.88021 2.72135 5.59375 2.07031C6.3125 1.41927 7.125 0.911458 8.03125 0.546875C8.9375 0.182292 9.90104 0 10.9219 0C12.0104 0 13.0339 0.208333 13.9922 0.625C14.9557 1.04167 15.8047 1.61719 16.5391 2.35156C17.2734 3.08594 17.849 3.9349 18.2656 4.89844C18.6875 5.85677 18.8984 6.88021 18.8984 7.96875C18.8984 9.05729 18.6901 10.0833 18.2734 11.0469C17.8568 12.0052 17.2812 12.8516 16.5469 13.5859C15.8125 14.3203 14.9635 14.8958 14 15.3125C13.0417 15.7292 12.0182 15.9375 10.9297 15.9375ZM6.25 2.91406C6.45312 3.04948 6.67448 3.17708 6.91406 3.29688C7.15365 3.41146 7.41406 3.51302 7.69531 3.60156C7.8724 3.11719 8.07552 2.6849 8.30469 2.30469C8.53385 1.92448 8.78125 1.60417 9.04688 1.34375C8.52083 1.48438 8.02083 1.6901 7.54688 1.96094C7.07812 2.22656 6.64583 2.54427 6.25 2.91406ZM8.70312 3.85938C8.96875 3.90625 9.24219 3.94531 9.52344 3.97656C9.8099 4.00781 10.1068 4.02865 10.4141 4.03906V1.53125C10.0807 1.67188 9.76562 1.94792 9.46875 2.35938C9.17188 2.76562 8.91667 3.26562 8.70312 3.85938ZM11.4375 4.03906C11.7448 4.02865 12.0417 4.00781 12.3281 3.97656C12.6146 3.94531 12.888 3.90625 13.1484 3.85938C12.9349 3.26562 12.6797 2.76562 12.3828 2.35938C12.0911 1.94792 11.776 1.67188 11.4375 1.53125V4.03906ZM14.1562 3.60156C14.724 3.42448 15.2031 3.19531 15.5938 2.91406C15.2083 2.54948 14.7786 2.23438 14.3047 1.96875C13.8359 1.69792 13.3359 1.48958 12.8047 1.34375C13.0755 1.60417 13.3255 1.92708 13.5547 2.3125C13.7839 2.69271 13.9844 3.1224 14.1562 3.60156ZM8.03125 7.45312H10.4141V5.0625C10.0651 5.05208 9.72135 5.02604 9.38281 4.98438C9.04427 4.94271 8.71875 4.89062 8.40625 4.82812C8.30729 5.22396 8.22396 5.64323 8.15625 6.08594C8.09375 6.52865 8.05208 6.98438 8.03125 7.45312ZM11.4375 7.45312H13.8203C13.8047 6.98438 13.763 6.52865 13.6953 6.08594C13.6328 5.64323 13.5495 5.22396 13.4453 4.82812C13.1328 4.89062 12.8073 4.94271 12.4688 4.98438C12.1354 5.02604 11.7917 5.05208 11.4375 5.0625V7.45312ZM14.8672 7.45312H17.8125C17.7604 6.74479 17.6016 6.06771 17.3359 5.42188C17.0703 4.77604 16.7214 4.1901 16.2891 3.66406C15.8047 4.02344 15.1927 4.32031 14.4531 4.55469C14.5729 4.99219 14.6667 5.45312 14.7344 5.9375C14.8021 6.42188 14.8464 6.92708 14.8672 7.45312ZM11.4375 10.9141C11.7917 10.9245 12.1354 10.9505 12.4688 10.9922C12.8021 11.0339 13.125 11.0859 13.4375 11.1484C13.5417 10.7422 13.6276 10.3151 13.6953 9.86719C13.763 9.41927 13.8047 8.95573 13.8203 8.47656H11.4375V10.9141ZM14.4531 11.4141C15.1927 11.6484 15.7995 11.9453 16.2734 12.3047C16.7057 11.7734 17.0573 11.1849 17.3281 10.5391C17.599 9.88802 17.7604 9.20052 17.8125 8.47656H14.8672C14.8464 9.01302 14.8021 9.52865 14.7344 10.0234C14.6667 10.513 14.5729 10.9766 14.4531 11.4141ZM11.4375 14.4141C11.776 14.2682 12.0885 13.9948 12.375 13.5938C12.6667 13.1927 12.9219 12.7005 13.1406 12.1172C12.6354 12.0234 12.0677 11.9635 11.4375 11.9375V14.4141ZM12.8203 14.5938C13.3359 14.4479 13.8255 14.2422 14.2891 13.9766C14.7578 13.7109 15.1849 13.3984 15.5703 13.0391C15.1953 12.7786 14.7214 12.5573 14.1484 12.375C13.9766 12.8385 13.7786 13.2578 13.5547 13.6328C13.3307 14.013 13.0859 14.3333 12.8203 14.5938ZM3.96875 16.0234C3.42708 16.0234 2.91667 15.9193 2.4375 15.7109C1.95833 15.5078 1.53646 15.224 1.17188 14.8594C0.807292 14.4948 0.520833 14.0729 0.3125 13.5938C0.104167 13.1146 0 12.6016 0 12.0547C0 11.5078 0.104167 10.9974 0.3125 10.5234C0.520833 10.0443 0.807292 9.6224 1.17188 9.25781C1.53646 8.88802 1.95833 8.60156 2.4375 8.39844C2.91667 8.1901 3.42708 8.08594 3.96875 8.08594C4.51562 8.08594 5.02865 8.1901 5.50781 8.39844C5.98698 8.60156 6.40885 8.88542 6.77344 9.25C7.13802 9.61458 7.42188 10.0365 7.625 10.5156C7.83333 10.9948 7.9375 11.5078 7.9375 12.0547C7.9375 12.5964 7.83333 13.1068 7.625 13.5859C7.41667 14.0651 7.1276 14.487 6.75781 14.8516C6.39323 15.2161 5.97135 15.5026 5.49219 15.7109C5.01302 15.9193 4.50521 16.0234 3.96875 16.0234ZM4.85156 14.4141C4.9401 14.3307 4.98438 14.224 4.98438 14.0938C4.98438 13.9688 4.9375 13.862 4.84375 13.7734L3.02344 12.0625L4.84375 10.3516C4.93229 10.263 4.97396 10.1562 4.96875 10.0312C4.96875 9.90625 4.92188 9.79948 4.82812 9.71094C4.74479 9.63281 4.64323 9.59635 4.52344 9.60156C4.40885 9.60156 4.30469 9.64583 4.21094 9.73438L2.21875 11.6094C2.06771 11.7552 1.99479 11.9115 2 12.0781C2.01042 12.2448 2.08333 12.3932 2.21875 12.5234L4.21094 14.3984C4.29948 14.4818 4.40625 14.5234 4.53125 14.5234C4.66146 14.5286 4.76823 14.4922 4.85156 14.4141Z" fill="#EBF2FA"/></svg>
                </span>
              </li>`;
            }
        }
    
        showlanglist.innerHTML = langlist;
        $('.weglot_custom_widget .selection_list').append('<ul>'+langlist+'</ul>');

        Weglot.on("languageChanged", function(newLang, prevLang) {
          console.log("The language on the page just changed to (code): " + newLang)
          console.log("The full name of the language is: " + Weglot.getLanguageName(newLang))
          var _thisbar = document.querySelector('.announcement-bar-section');
          document.documentElement.style.setProperty('--announcementbar-height', `${_thisbar.offsetHeight}px`);
          $('.announcement_bar_slider_custom').slick('refresh');
        });

        var _thisbar = document.querySelector('.announcement-bar-section');
        document.documentElement.style.setProperty('--announcementbar-height', `${_thisbar.offsetHeight}px`);
    
        $('body').on('click','.weglot_custom_widget .selection_list li', function(){
          $('.weglot_custom_widget .selection_list li').removeClass('selected');
          $(this).addClass('selected');
          Weglot.switchTo($(this).attr('data-val'));
          $('.weglot_custom_widget .selection_list').removeClass('active');
        });
    
        $('body').on('click','.weglot_custom_widget .weglot_lang_button', function(){
          $('.weglot_custom_widget .selection_list').addClass('active');
          $('.weglot_custom_widget .tooltip').addClass('hide').hide();
          $('.weglot_custom_widget #myweglotDiv').addClass('hide').hide();
          sessionStorage.setItem('widget_clicked', 'true');
        });
        $('body').on('click','.selection_list .selector_close_btn', function(){
          $('.weglot_custom_widget .selection_list').removeClass('active');
        });

        if(!sessionStorage.getItem('widget_clicked')){
          $('.weglot_custom_widget .tooltip').removeClass('hide').show();
          $('.weglot_custom_widget #myweglotDiv').removeClass('hide').show();
        }
    
        setInterval(function(){
    
          var $ul = $('.lang_list_animation');
          var itemHeight = $ul.find('li').outerHeight();
    
          var $first = $ul.find('li:first');
    
          $first.animate({
            marginTop: -itemHeight
          }, 400, function(){
            $first.appendTo($ul).css('marginTop', 0);
          });
    
        }, 1500);
      }
    },2000)

    $('body').on('click','.tooltipclose', function(){
      $('.weglot_custom_widget .tooltip').addClass('hide').hide();
      sessionStorage.setItem('widget_clicked', 'true');
    });
  }
  

});


// function initActiveScroll() {
//   const container = document.querySelector(".videolist_flex");
//   const items = document.querySelectorAll(".videomodel_wrapper");
//   if (!container || !items.length) return;

//   function updateActiveItem() {
//     let containerRect = container.getBoundingClientRect();
//     let containerCenter = containerRect.left + containerRect.width / 2; // for horizontal scroll

//     let closest = null;
//     let closestDist = Infinity;

//     items.forEach((item) => {
//       const rect = item.getBoundingClientRect();
//       const itemCenter = rect.left + rect.width / 2;
//       const dist = Math.abs(containerCenter - itemCenter);

//       if (dist < closestDist) {
//         closestDist = dist;
//         closest = item;
//       }
//     });

//     // Remove all previous states
//     items.forEach((el) => el.classList.remove("active", "prev", "next"));

//     // Add new states
//     if (closest) {
//       closest.classList.add("active");
//       if (closest.previousElementSibling) closest.previousElementSibling.classList.add("prev");
//       if (closest.nextElementSibling) closest.nextElementSibling.classList.add("next");
//     }
//   }

//   // Run initially and on scroll
//   updateActiveItem();
//   container.addEventListener("scroll", () => {
//     requestAnimationFrame(updateActiveItem);
//   });
// }

// // Run after DOM ready and handle Shopify section reloads
// document.addEventListener("DOMContentLoaded", initActiveScroll);
// document.addEventListener("shopify:section:load", initActiveScroll);

// function initScrollButtons() {
//   const container = document.querySelector(".videolist_flex");
//   const items = document.querySelectorAll(".videomodel_wrapper");
//   const leftBtn = document.querySelector(".scroll-btn.left");
//   const rightBtn = document.querySelector(".scroll-btn.right");
//   if (!container || !items.length) return;

//   const scrollAmount = items[0].offsetWidth + 20; // slide width + gap

//   leftBtn.addEventListener("click", () => {
//     container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
//   });

//   rightBtn.addEventListener("click", () => {
//     container.scrollBy({ left: scrollAmount, behavior: "smooth" });
//   });
// }

// document.addEventListener("DOMContentLoaded", initScrollButtons);
// document.addEventListener("shopify:section:load", initScrollButtons);
